import ContentManagementPageTitle from './ContentManagementPageTitle';

export default ContentManagementPageTitle;
